import { render, staticRenderFns } from "./ThemePicker.vue?vue&type=template&id=166969aa&"
import script from "./ThemePicker.vue?vue&type=script&lang=js&"
export * from "./ThemePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports